export default "__VITE_ASSET__D4y_NoCK__"